import { ForwardTenIcon } from "../icons";
import { cn } from "../lib/cn";
import { getPlayerControlButtonClasses } from "../lib/shared-styles";

export type SeekForwardButtonProps = {
  onSeekForward: () => void;
  size?: "xs" | "sm" | "md" | "player" | "lg";
  color?: "black" | "white";
  disabled?: boolean;
  className?: string;
};

export function SeekForwardButton({
  onSeekForward,
  size = "md",
  color = "black",
  disabled = false,
  className,
}: SeekForwardButtonProps) {
  return (
    <button
      type="button"
      onClick={onSeekForward}
      disabled={disabled}
      aria-label="Seek forward 10 seconds"
      className={cn(
        getPlayerControlButtonClasses({ color, disabled }),
        {
          "size-[1.4rem]": size === "xs",
          "size-[1.61056rem]": size === "sm",
          "size-8": size === "md" || size === "player",
          "size-16": size === "lg",
        },
        className,
      )}
      aria-disabled={disabled}
      data-size={size}
      data-testid="audio-seek-forward-button"
      data-color={color}
    >
      <ForwardTenIcon
        aria-hidden="true"
        className={cn("fill-current", {
          "size-[1.4rem]": size === "xs",
          "size-[1.61056rem]": size === "sm",
          "size-8": size === "md" || size === "player",
          "size-12": size === "lg",
        })}
      />
    </button>
  );
}
